module.exports = __webpack_public_path__ + "static/media/ellipsis.f975ba2b.svg";